import React, { useState } from 'react';
import { CssBaseline } from "@mui/material";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Box } from '@material-ui/core';

import TopBar from './TopBar';
import Copyright from './Copyright';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
    minWidth: 0,
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    fontFamily: '"Georgia", "Times New Roman", serif',
    lineHeight: 1.8,
    color: '#1a1a1a',
    background: '#fafafa',
  },
  container: {
    width: '100%',
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 60px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '0 30px',
    },
  },
  main: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
    minWidth: 0,
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  footer: {
    backgroundColor: '#0d0d0d',
    color: '#ffffff',
    padding: '40px',
    width: '100%',
    textAlign: 'center',
  },
  footerContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '40px',
    textAlign: 'left',
  },
  footerLogo: {
    height: '100px',
    marginBottom: '5px',
  },
  footerText: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '14px',
    marginBottom: '20px',
    lineHeight: 1.6,
    fontFamily: '"Segoe UI", sans-serif',
  },
  footerHeading: {
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: '15px',
    position: 'relative',
    paddingBottom: '10px',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '40px',
      height: '2px',
      backgroundColor: '#d4145a',
    },
  },
  footerLinks: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    '& li': {
      marginBottom: '10px',
    },
    '& a': {
      color: 'rgba(255, 255, 255, 0.7)',
      textDecoration: 'none',
      transition: 'color 0.3s',
      fontSize: '14px',
      fontFamily: '"Segoe UI", sans-serif',
      '&:hover': {
        color: '#ffffff',
      },
    },
  },
  contactInfo: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    '& li': {
      marginBottom: '10px',
      display: 'flex',
      fontSize: '14px',
      color: 'rgba(255, 255, 255, 0.7)',
      fontFamily: '"Segoe UI", sans-serif',
    },
    '& i': {
      marginRight: '10px',
      color: '#d4145a',
    },
  },
  copyright: {
    textAlign: 'center',
    paddingTop: '20px',
    marginTop: '40px',
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.5)',
    fontFamily: '"Segoe UI", sans-serif',
    opacity: 0.7,
  },
}));

export default function Main(props) {
  const { history, children } = props;
  const classes = useStyles();
  const [openSidebar, setOpenSidebar] = useState(false);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <TopBar props={history}/>
      <main className={classes.main}>
        {children}
      </main>
      <footer className={classes.footer}>
        <div className={classes.container}>
          <div className={classes.footerContainer}>
            <div>
              <img src={require("../../assets/logofinal.png")} alt="LegalSutra Logo" className={classes.footerLogo} />
              <p className={classes.footerText}>LegalSutra provides comprehensive legal services to businesses and individuals, combining legal expertise with innovative technology solutions.</p>
            </div>
            
            <div>
              <h3 className={classes.footerHeading}>Quick Links</h3>
              <ul className={classes.footerLinks}>
                <li><a href="/#services">Our Services</a></li>
                <li><a href="/#practice-areas">Practice Areas</a></li>
                <li><a href="/#cases">Success Stories</a></li>
                <li><a href="/#contact">Contact Us</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className={classes.footerHeading}>Practice Areas</h3>
              <ul className={classes.footerLinks}>
                <li><a href="/civil-disputes">Litigation</a></li>
                <li><a href="/corporate-legal">Corporate Law</a></li>
                <li><a href="/property-matters">Property Law</a></li>
                <li><a href="/family-law">Family Law</a></li>
                <li><a href="/criminal-case">Criminal Law</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className={classes.footerHeading}>Contact Us</h3>
              <ul className={classes.contactInfo}>
                <li><i>📍</i> HD-210, Duplex Villas, Sector-135, Noida-201304, India</li>
                <li><i>📱</i> +91 9911512400</li>
                <li><i>✉️</i> mail@legalsutra.co.in</li>
              </ul>
            </div>
          </div>
          
          <div className={classes.copyright}>
            &copy; {new Date().getFullYear()} LegalSutra. All Rights Reserved.
            <Copyright />
          </div>
        </div>
      </footer>
    </div>
  );
}

Main.propTypes = {
  children: PropTypes.node
};